import { Theme } from '@radix-ui/themes'
import * as React from 'react'
import { useSelector } from 'hooks/use-redux'
import Button from 'components/ui/button'
import Modal from 'components/ui/disco-modal'
import modalStyles from 'components/utils/modalStyles'
import styles from './index.module.css'

type Props = {
  onRequestClose: (...args: Array<any>) => any
}

const UpdateSuccessPlanModal = ({ onRequestClose }: Props): React.ReactNode => {
  const auto_tagging_tracks_limit = useSelector(
    state => state.user?.business?.auto_tagging_tracks_limit,
  )
  const watermarked_playlists_quota = useSelector(
    state =>
      state.user?.business?.private_metadata?.watermarked_playlists_quota,
  )
  const planName = useSelector(
    state => state.user?.business?.private_metadata?.plan.name,
  )
  let message = '.'

  if (auto_tagging_tracks_limit && watermarked_playlists_quota) {
    message = ', Discovery Suite and Watermarking.'
  } else if (auto_tagging_tracks_limit) {
    message = ' and Discovery Suite.'
  } else if (watermarked_playlists_quota) {
    message = ' and Watermarking.'
  }

  return (
    <Modal style={modalStyles} onRequestClose={onRequestClose}>
      <Theme>
        <h2 className={styles.updateSuccessPlanModalTitle}>
          Subscription confirmed!
        </h2>
        <p className={styles.updateSuccessPlanModalDescription}>
          Thanks for subscribing to DISCO. You’re subscribed to the {planName}{' '}
          plan{message}
        </p>
        <div className={styles.updateSuccessPlanModalButtonContainer}>
          <div>
            <Button
              caption="Get started"
              appearance="primary"
              onClick={onRequestClose}
            />
          </div>
        </div>
      </Theme>
    </Modal>
  )
}

export default UpdateSuccessPlanModal
